import styles from './Cheatsheets.module.css';

export default function Cheatsheets() {

    const openPdfInNewTab = (url) => {
        window.open(url, '_blank'); // Open the PDF in a new tab
    };

    return (
        <div className={styles.cheatsheetsSection}>
            <div className={styles.cheatsheetsSectionContent}> 
                
                <h1 className={styles.cheatsheetsSectionTitle}>Cheatsheets</h1>

                <div className={styles.allCheatsheets}>

                    <div className={styles.cheatsheet} 
                    style={{ 
                        backgroundImage: "url('assets/cheatsheet_covers/irregular_verbs_zh.png')",
                        backgroundSize: 'cover'
                    }}
                    onClick={() => openPdfInNewTab('/materials/cheatsheets/irregular_verbs_zh.pdf')}>
                    </div>

                    <div className={styles.cheatsheet} 
                    style={{ 
                        backgroundImage: "url('assets/cheatsheet_covers/active_tenses.png')",
                        backgroundSize: 'cover'
                    }}
                    onClick={() => openPdfInNewTab('/materials/cheatsheets/active_tenses.pdf')}>
                    </div>

                    <div className={styles.cheatsheet} 
                    style={{ 
                        backgroundImage: "none",
                        backgroundSize: 'cover'
                    }}
                    onClick={() => openPdfInNewTab('/pdfs/cheatsheet1.pdf')}>
                    </div>



                    

                    

                </div>
            </div>
        </div>
    );
}
